import { NgClass, UpperCasePipe } from "@angular/common";
import {
  Component,
  computed,
  EventEmitter,
  HostListener,
  inject,
  input,
  Output,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router, RouterLink } from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { ArgumentRatingIcon } from "../../../shared/components/argument-rating-icon/argument-rating-icon";
import { DefaultArgument } from "../../../shared/pia-api/generated";
import { FavoriteArgumentsService } from "../../../shared/services/favorite-arguments.service";

@Component({
  selector: "claas-product-argument-row",
  imports: [
    IconComponent,
    TranslatePipe,
    UpperCasePipe,
    NgClass,
    RouterLink,
    ArgumentRatingIcon,
  ],
  templateUrl: "./product-argument-row.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-argument-row.scss",
})
export class ProductArgumentRow {
  private favoriteArgumentsService = inject(FavoriteArgumentsService);
  private router = inject(Router);
  isHovered = signal(false);
  productArgument = input.required<DefaultArgument>();
  favoriteProductArguments = toSignal(
    this.favoriteArgumentsService.includedDocumentIds$,
  );
  isFavourite = computed(
    () =>
      this.productArgument().ID &&
      this.favoriteProductArguments()?.includes(
        this.productArgument().ID as string,
      ),
  );

  @Output() expandArgumentDetail = new EventEmitter<boolean>();
  /**
   * delegate row click to router target within the found a tag
   * checks if the favorite button was the clicked element to prevent navigation when
   * favorite button was clicked
   * @param evt
   */
  @HostListener("click", ["$event"])
  onRowClick(evt: MouseEvent) {
    const { currentTarget, target } = evt;
    const anchorDelegateTarget = (
      (currentTarget as HTMLElement)?.querySelector("a") as HTMLAnchorElement
    )?.href;
    const favoriteButtonElement = (currentTarget as HTMLElement)?.querySelector(
      "button",
    ) as HTMLButtonElement;
    if (
      anchorDelegateTarget &&
      target &&
      !(
        target === favoriteButtonElement ||
        favoriteButtonElement.contains(target as HTMLElement)
      )
    ) {
      const { pathname, searchParams } = new URL(anchorDelegateTarget);
      this.router.navigate([pathname], { queryParams: searchParams });
      this.expandArgumentDetail.emit(true);
    }
  }

  addArgumentToFavorites(id?: string): void {
    if (!id) return;
    if (!this.favoriteProductArguments()?.includes(id)) {
      this.favoriteArgumentsService.add(id as string);
    } else {
      this.favoriteArgumentsService.remove(id as string);
    }
  }
}
